import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import './sidebar-page.scss';

type Props = {
  sidebarContent: any,
  sidebarMarginTop?: number,
  sidebarWidth?: 'wide' | 'narrow',
  align?: 'left' | 'right',
  scrollable?: boolean,
  customClass?: string,
  children: React.ReactNode
};

const SidebarPage = ({
  sidebarContent,
  sidebarMarginTop = 0,
  sidebarWidth = 'narrow',
  children,
  customClass,
  scrollable = false,
  align = 'left'
}: Props) => {
  const classes = classnames({
    'sidebar-page': true,
    'sidebar-page--scrollable': scrollable,
    [String(customClass)]: customClass,
    [`sidebar-page--width-${sidebarWidth}`]: sidebarWidth
  });

  const sidebarClasses = classnames({
    'sidebar-page__sidebar': true,
    [`sidebar-page__sidebar--align-${align}`]: align
  });

  return (
    <section className={classes}>
      {
        !isNil(sidebarContent) &&
          <div
            className={sidebarClasses}
            style={{
              marginTop: sidebarMarginTop
            }}
          >
            <div
              className="sidebar-page__wrapper"
              data-for-scroller="side-page-wrapper"
            >
              {sidebarContent}
            </div>
          </div>
      }
      <div className="sidebar-page__content">
        {children}
      </div>
    </section>
  );
};

export default SidebarPage;
